import { useShow, useTranslate } from '@refinedev/core';
import { Show, DateField } from '@refinedev/antd';
import { Typography, Divider, Descriptions, Tag } from 'antd';
import type { MonetizationProductDetailOut } from '@/api/generated/schemas';
import { RevenueCatProductLink } from '@/components/monetization/RevenueCatLink';

const { Title } = Typography;

export const MonetizationProductShow = () => {
  const t = useTranslate();
  const { query } = useShow<MonetizationProductDetailOut>({
    resource: 'monetization.products',
  });
  const { data, isLoading } = query;
  const record = data?.data;

  return (
    <Show isLoading={isLoading}>
      <Title level={4}>{t('base.sections.basic_info')}</Title>

      <Descriptions bordered column={2} size="small">
        <Descriptions.Item label={t('base.fields.id')}>
          {record?.id}
        </Descriptions.Item>
        <Descriptions.Item
          label={t('monetization.products.fields.revenuecat_product_id')}
        >
          {record?.revenuecat_product_id ? (
            <RevenueCatProductLink
              id={record.revenuecat_product_id}
              title={t('monetization.products.actions.open_in_revenuecat')}
            />
          ) : (
            '-'
          )}
        </Descriptions.Item>
        <Descriptions.Item
          label={t('monetization.products.fields.display_name')}
          span={2}
        >
          {record?.display_name ?? '-'}
        </Descriptions.Item>
        <Descriptions.Item
          label={t('monetization.products.fields.localized_display_name_en')}
        >
          {record?.localized_display_name?.en ?? '-'}
        </Descriptions.Item>
        <Descriptions.Item
          label={t('monetization.products.fields.localized_display_name_pl')}
        >
          {record?.localized_display_name?.pl ?? '-'}
        </Descriptions.Item>
      </Descriptions>

      <Divider />
      <Title level={4}>{t('monetization.products.sections.store')}</Title>

      <Descriptions bordered column={2} size="small">
        <Descriptions.Item label={t('monetization.products.fields.store')}>
          {record?.store ? <Tag>{record.store}</Tag> : '-'}
        </Descriptions.Item>
        <Descriptions.Item
          label={t('monetization.products.fields.product_type')}
        >
          {record?.product_type ? <Tag>{record.product_type}</Tag> : '-'}
        </Descriptions.Item>
        <Descriptions.Item
          label={t('monetization.products.fields.store_product_identifier')}
          span={2}
        >
          {record?.store_product_identifier ?? '-'}
        </Descriptions.Item>
      </Descriptions>

      <Divider />
      <Title level={4}>{t('base.sections.system_info')}</Title>

      <Descriptions bordered column={2} size="small">
        <Descriptions.Item label={t('monetization.products.fields.created_at')}>
          {record?.created_at ? (
            <DateField value={record.created_at} format="LLL" />
          ) : (
            '-'
          )}
        </Descriptions.Item>
        <Descriptions.Item label={t('monetization.products.fields.updated_at')}>
          {record?.updated_at ? (
            <DateField value={record.updated_at} format="LLL" />
          ) : (
            '-'
          )}
        </Descriptions.Item>
        <Descriptions.Item label={t('monetization.products.fields.version')}>
          {record?.version ?? '-'}
        </Descriptions.Item>
      </Descriptions>
    </Show>
  );
};
